export default function ShowCard({ children, show }) {
  return show ? children : null;
}

export function conditionByFilter(filter, keys) {
  return keys.every((key) => !filter[key]);
}
